var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-2 bg-[#F9F9FB] border border-grayNeutralLight rounded"},[_c('svg',{attrs:{"width":"16","height":"16"}},[_c('use',{attrs:{"xlink:href":`#${_vm.icon}`}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }